
const WRX = document.getElementById('wrx');
const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in-view'); io.unobserve(e.target); } }), { threshold: .18 });
WRX.querySelectorAll('.wrx-reveal,.bar-anim').forEach(el => io.observe(el));

const scenes = [...WRX.querySelectorAll('[data-scene]')];
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
function drive(){
  const vh = innerHeight;
  scenes.forEach(sc => {
    const r = sc.getBoundingClientRect();
    let p = (vh * 0.52 - r.top) / (vh * 0.58);
    p = Math.max(0, Math.min(1, p));
    if (reduced) p = 1;
    sc.querySelector('.p-drive').style.setProperty('--p', p.toFixed(3));
    sc.classList.toggle('active', p > .12 && p < 1.35 && !reduced);
  });
}
addEventListener('scroll', () => requestAnimationFrame(drive), {passive:true});
addEventListener('resize', drive);
drive();

// ===== interactive WeRevive library demo (no levels: area -> play) =====
const AREAS = ["Foot","Calf & Ankle","Shin","Hamstring","Inner Thigh","Middle Thigh","Outer Thigh","Hip Flexor & Psoas","Hip","Glute","Lat","Chest","Rotator Cuff","Shoulder","Trap","Bicep","Tricep","Forearm","Hand"];
const demo = document.getElementById('libdemo');
if (demo) {
  const show = n => {
    demo.querySelectorAll('.demo-screen').forEach(s => s.hidden = s.dataset.screen != n);
    demo.querySelectorAll('.dstep').forEach(d => d.classList.toggle('on', +d.dataset.dstep <= n));
  };
  const wrap = document.getElementById('areas');
  AREAS.forEach(a => {
    const el = document.createElement('button');
    el.className = 'areabtn'; el.textContent = a;
    el.addEventListener('click', () => {
      document.getElementById('vidtitle').textContent = a + ' Revive With Your WeRevive';
      show(2);
    });
    wrap.appendChild(el);
  });
  demo.querySelectorAll('.demo-back').forEach(b => b.addEventListener('click', () => show(b.dataset.back)));
}

// ===== hero gallery =====
const sl = document.getElementById('hslider');
if (sl) {
  const slides = [...sl.children];
  const dots = document.getElementById('hdots');
  slides.forEach((_, i) => {
    const d = document.createElement('button');
    d.className = 'hdot' + (i === 0 ? ' on' : '');
    d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
    d.addEventListener('click', () => sl.scrollTo({left: i * sl.clientWidth, behavior: 'smooth'}));
    dots.appendChild(d);
  });
  const upd = () => {
    const i = Math.round(sl.scrollLeft / sl.clientWidth);
    dots.querySelectorAll('.hdot').forEach((d, j) => d.classList.toggle('on', j === i));
  };
  sl.addEventListener('scroll', () => requestAnimationFrame(upd), {passive: true});
  WRX.querySelector('.hprev').addEventListener('click', () => sl.scrollBy({left: -sl.clientWidth, behavior: 'smooth'}));
  WRX.querySelector('.hnext').addEventListener('click', () => sl.scrollBy({left: sl.clientWidth, behavior: 'smooth'}));
}
